import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class CreditPurchaseModel extends Model {
    constructor(
        public paymentId: number = 0,
        public creditsGranted: number = 0,
        public originalAmount: number = 0,
        public discountAmount: number = 0,
        public amountCharged: number = 0,
        public currency: string = ""
    ) {
        super();
    }

    public static create(model: Partial<CreditPurchaseModel>): CreditPurchaseModel {
        return createModel<CreditPurchaseModel>(CreditPurchaseModel, { ...model });
    }
}
